/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum SignProvider {
    VariasSign = 'VariasSign',
    ServoSign = 'ServoSign',
    BrokernetSign = 'BrokernetSign'
  }

    export const SignProviderTranslocoMap: Record<SignProvider, string> = {
    [SignProvider.VariasSign]: 'signProvider.variasSign',
    [SignProvider.ServoSign]: 'signProvider.servoSign',
    [SignProvider.BrokernetSign]: 'signProvider.brokernetSign',
    };

    export const SignProviderOptions = [
  { value: SignProvider.VariasSign, labelKey: 'signProvider.variasSign' },
  { value: SignProvider.ServoSign, labelKey: 'signProvider.servoSign' },
  { value: SignProvider.BrokernetSign, labelKey: 'signProvider.brokernetSign' },
    ];

